import Loader from "@/components/site/Loader";
import ScrollProgress from "@/components/site/ScrollProgress";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import WhyChoose from "@/components/site/WhyChoose";
import Impact from "@/components/site/Impact";
import Clients from "@/components/site/Clients";
import CTA from "@/components/site/CTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Landing = () => {
  const params =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();
  const noAnim = params.has("static");
  const off = parseInt(params.get("off") || "0", 10);
  return (
    <div
      className={`relative bg-warm ${noAnim ? "no-anim" : ""}`}
      style={off ? { marginTop: `-${off}px` } : undefined}
    >
      <Loader />
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Industries />
        <WhyChoose />
        <Impact />
        <Clients />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
